/* tslint:disable */

/**
 */
export class RfidCardCreate {
    rfid?: string;
    barcode?: string;
}
